import { useNavigate } from 'react-router-dom'
import Icon from '@/components/icon'
import Image from '@/components/image'
import logo from '@/assets/img/logo.png'
import Styles from './style.module.scss'
import { Flex } from 'antd'
import { footerNavData } from './data'

const Social = () => {
  return (
    <div className={Styles.social}>
      <a href='https://www.facebook.com/profile.php?id=61573679550578' target='_blank' rel='noreferrer'>
        <Icon name='facebook' />
      </a>
      <a href='https://www.instagram.com/carusenergy' target='_blank' rel='noreferrer'>
        <Icon name='instagram' />
      </a>
      <a href='https://www.linkedin.com/company/carus-energy-incorporated' target='_blank' rel='noreferrer'>
        <Icon name='linkedIn' />
      </a>
    </div>
  )
}

export default function Footer() {
  const navigate = useNavigate()

  return (
    <Flex justify='center' className={Styles.footer}>
      <div className={Styles.left}>
        <Image src={logo} alt='logo' className={Styles.logo} />
        <div className={Styles.follow}>Follow us on social media</div>
        <Social />
      </div>
      <Flex className={Styles.right}>
        {footerNavData.map(d => (
          <Flex vertical align='flex-start' className={Styles.column} key={d.title}>
            <div className={Styles.title} onClick={() => d?.path && navigate(d.path)}>
              {d.title}
            </div>
            {!!d?.children?.length && (
              <Flex vertical align='flex-start' className={Styles.children}>
                {d.children.map(i => (
                  <div
                    className={Styles.item}
                    key={i.title}
                    onClick={() => (i.path?.startsWith('http') ? window.open(i.path, '_blank') : navigate(i.path))}
                  >
                    {i.title}
                  </div>
                ))}
              </Flex>
            )}
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
